// extracted by mini-css-extract-plugin
export default {"rightSection":"ryR4VpW3ikPlCrzu0O7Y","qrButton":"EAnw7_Wl8RMmny6yYm0F"};